import { Fragment } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Logo from "../../utils/components/Logo";

function NotFound() {
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated); // check if user is authenticated from redux state
  return (
    <Fragment>
      <main className="colCenterWithoutMenu">
        <Logo to="" />
        <br></br>
        <img
          src={process.env.PUBLIC_URL + "/images/errors.svg"}
          alt="Error page. Something went wrong!"
        />
        <h1>
          Ups!!!<br></br>Something went wrong
        </h1>
        {isAuthenticated && (
          <>
            <div className="blueRect">
              <Link to="/" className="btn btnBox btnWhite">
                <b>Back to profile</b>
              </Link>
            </div>
          </>
        )}
        {!isAuthenticated && (
          <>
            <div className="blueRect">
              <Link to="/" className="btn btnBox btnWhite">
                <b>Back to Home</b>
              </Link>
              <Link to="/sign-in" className="btn btnBox btnWhite">
                <b>Sign In</b>
              </Link>
              <Link to="/sign-up" className="btn btnBox btnWhite">
                <b>Create Account</b>
              </Link>
            </div>
          </>
        )}
      </main>
    </Fragment>
  );
}

export default NotFound;
